import { FC, useMemo } from 'react'
import { Flex } from '@chakra-ui/react'

import { DynamicTextsByType, RefreshButton } from 'components'
import { getAdvancedFilterRuleLabelFeedback } from '../../utils/getAdvancedFilterRuleLabelFeedback'
import { METADATA_INITIAL_FILTER } from '../../constants'

type Props = {
  metadatasInfos: any[]
  filter: any
  setFilter: any
  metadata?: any
  onClose: () => void
}

const MetadatasValues: FC<Props> = ({ metadatasInfos, filter, setFilter, onClose, metadata }) => {
  const metadatasWithValuesInArray = useMemo(() => {
    return metadatasInfos.filter(({ label, info }) => label !== null && info !== '')
  }, [metadatasInfos])

  function resetMetadataFilter() {
    setFilter({ ...filter, ...METADATA_INITIAL_FILTER })
    onClose()
  }

  if (!metadata.name) return null

  return (
    <Flex minWidth="100%" direction="column" align="flex-start" px={4} pb={metadatasWithValuesInArray.length > 0 ? 4 : 0} gap={2}>
      {metadata.name &&
        metadatasWithValuesInArray.map(({ rule, info, label, type }) => {
          return <DynamicTextsByType key={label} type={type} label={getAdvancedFilterRuleLabelFeedback(rule, label)} value={info} />
        })}

      {metadatasWithValuesInArray.length > 0 && (
        <RefreshButton mt={2} minWidth="100%" onClick={resetMetadataFilter} variant="outline">
          Limpar filtros
        </RefreshButton>
      )}
    </Flex>
  )
}

export default MetadatasValues
